import ApiClient from '../../base/api';
import { FindCityRequestParams } from '../../base/interfaces/api';
import { City } from '../../base/interfaces/config';
import { ConfigResponse, SendVerificationEmailParams } from './interfaces';

const apiClient = new ApiClient();

export const recruiterApi = {
    getConfig: () => apiClient.get<ConfigResponse>('/api/config'),
    findCity: (data: FindCityRequestParams, signal?: AbortSignal) =>
        apiClient.post<FindCityRequestParams, City[]>('/api/find-city ', data, { signal }),
    sendVerificationEmail: (data: SendVerificationEmailParams) =>
        apiClient.post<SendVerificationEmailParams, void>('/api/send-email', data),
};
